import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Hoja } from 'src/app/hojas-call-center/models/Hoja';
import { environment } from 'src/environments/environment';

@Injectable({providedIn: 'root'})

export class BookingService
{
  private hostPeticion : string = environment.hojaWSBase;

  constructor(private http: HttpClient){}

  insertPayload(token:string, query:any):Promise<string>
  {
    let url:string = this.hostPeticion +"/BookingPayloads";
    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }



    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,query,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  buscarArticuloPayload(token:string, case_id:string):Promise<any>
  {
    let url:string = this.hostPeticion +"/BookingPayloads/getArticulosCC";
    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,'"'+case_id+'"',httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }
}
